
const global = {
  // http: "http://localhost:8080/",//本地环境
  // webSocket: "ws://localhost:8080/webSocket/",//本地环境
  http: "https://vac.huayundata.com/api-ji/",//生产环境
  webSocket: "wss://vac.huayundata.com/webSocket/",//生产环境
  imgSrc: "https://vac.huayundata.com/anji-file/",
  jurisdiction: JSON.parse(localStorage.getItem("jurisdiction")), //权限
};

/***权限***/
global.power = function (val) {
  var data = JSON.parse(localStorage.getItem("jurisdiction"));
  if (data != null) {
    return data.hasOwnProperty(val);
  }
  return false;
},

  global.workOrderStart = function (val) {
    switch (val) {
      case 0:
        val = "草稿";
        break;
      case 1:
        val = "未指派";
        break;
      case 2:
        val = "正在处理";
        break;
      case 3:
        val = "无法处理";
        break;
      case 4:
        val = "复核中";
        break;
      case 5:
        val = "处理成功";
        break;
      case 6:
        val = "正常巡检";
        break;
      case 7:
        val = "抢修填写";
        break;
      case 8:
        val = "抢修处理";
        break;
      case 9:
        val = "抢修审核";
        break;
    }
    return val;
  },

  /***页面禁止滚动***/
  global.stop = function () {
    var mo = function (e) {
      e.preventDefault();
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("touchmove", mo, false); //禁止页面滑动
  },

  /***取消滚动限制***/
  global.move = function () {
    var mo = function (e) {
      e.preventDefault();
    };
    document.body.style.overflow = ""; //出现滚动条
    document.removeEventListener("touchmove", mo, false);
  },

  /***通用下载方法***/
  global.download = function (fileName) {
    window.location.href = global.http + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true;
  },


  /***获取当天日期***/
  global.date = function (val) {
    if (val == "date") {
      val = new Date().getFullYear() + "-" + (new Date().getMonth() + 1).toString().padStart(2, "0") + "-" + new Date().getDate().toString().padStart(2, "0");
    } else if (val == "month") {
      val = new Date().getFullYear() + "-" + (new Date().getMonth() + 1).toString().padStart(2, "0");
    }
    return val;
  }
export default global;



// WEBPACK FOOTER //
// ./src/global.js